import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.toggleSubmit()
  }

  toggleSubmit() {
    const hasFile = this.inputTarget.files && this.inputTarget.files.length > 0
    this.submitTarget.disabled = !hasFile

    if (hasFile) {
      this.submitTarget.classList.remove("opacity-50", "cursor-not-allowed")
    } else {
      this.submitTarget.classList.add("opacity-50", "cursor-not-allowed")
    }
  }

  upload() {
    if (this.inputTarget.files && this.inputTarget.files.length > 0) {
      this.element.requestSubmit()
    }
  }
}
